import * as React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/utils/common.utils";

interface SectionCardProps extends Omit<React.ComponentPropsWithoutRef<typeof Card>, "title"> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  headerClassName?: string;
  contentClassName?: string;
}

export default function SectionCard({ title, description, action, children, className, headerClassName, contentClassName, ...props }: SectionCardProps) {
  return (
    <Card className={cn("rounded-xl border-dash-border bg-white shadow-none", className)} {...props}>
      {(title || description || action) && (
        <CardHeader className={cn("flex-col items-start gap-4 p-6 sm:flex-row sm:justify-between", description ? "items-start" : "sm:items-center", headerClassName)}>
          <div className="min-w-0">
            {title && <CardTitle className="text-sm font-semibold text-dash-ink">{title}</CardTitle>}
            {description && <CardDescription className="mt-1">{description}</CardDescription>}
          </div>
          {action && <div className="flex w-full shrink-0 items-center sm:w-auto">{action}</div>}
        </CardHeader>
      )}
      <CardContent className={cn("p-6", (title || description || action) && "pt-0", contentClassName)}>{children}</CardContent>
    </Card>
  );
}
